import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon,
  Delete as Delete,
  LibraryBooksOutlined,
  SchoolOutlined,
  AccountBox,
  MyLocationOutlined,
  NotificationsActiveOutlined,
  SettingsOutlined,
  CalendarTodayOutlined,
  PausePresentationOutlined,
  AlarmOnOutlined,
  ExitToAppOutlined,
  LocalAtmOutlined,
  DashboardOutlined,
  PeopleAlt,
  Memory
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import Cookies from 'universal-cookie';

// Local imports 
import getClient from '../../services/getClient';
import checkUtente from '../../services/checkUtente';

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import translateString from "../../utils/Locales";

let t = translateString;

function Sidebar({ location, ...props }) {
  var classes = useStyles();
  var theme = useTheme();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);
  var [logo, setLogo] = useState(null)
  const [locked, setLocked] = useState(false);

  useEffect(function() {
     
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
      
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  useEffect(() => {
      checkCurrentUser();
  }, []);

  const checkCurrentUser = async () => {
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentUser = await checkUtente(username, token, username);

    if (currentUser && currentUser[0].type != 0) {
      setLocked(true);
    }
  };

  let jsonItems = [];
  try {
    jsonItems = props.menuItems;
  }
  catch (error){}

  const loadStart = async () => {
    const db = cookies.get('db', { path: '/' });
    const client = await getClient(username, token, db);
    if (client) {
      setLogo(client.logoImage);
    }
    
  }

  const cookies = new Cookies();
  const username = cookies.get('username', { path: '/' });
  const token = cookies.get('token', { path: '/' });
  const userType = window.sessionStorage.getItem('user_type');

  loadStart()

  let mainStructure = [
    { id: 20, label: "Dashboard", link: "/app/dashboard", icon: <DashboardOutlined /> },
    { id: 21, label: "" },
    { id: 0, type: "title", label: t('gestione'), adminLocked: false },
    { id: 1, label: t('corsi'), link: "/app/corsi", icon: <LibraryBooksOutlined />, adminLocked: locked },
    { id: 3, label: t('studenti'), link: "/app/studenti", icon: <SchoolOutlined />, adminLocked: locked },
    { id: 4, label: t('insegnanti'), link: "/app/insegnanti", icon: <AccountBox />, adminLocked: locked },
    { id: 5, label: t('aule'), link: "/app/aule", icon: <MyLocationOutlined />, adminLocked: locked },
    { id: 22, label: t('notifiche'), link: "/app/notifiche", icon: <NotificationsActiveOutlined />, adminLocked: locked },
    { id: 6, label: t('feste'), link: "/app/scuola", icon: <CalendarTodayOutlined />, adminLocked: locked },
    { id: 7, type: "divider", adminLocked: false },
    { id: 9, label: t('cestino'), link: "/app/cestinoCorsi", icon: <Delete />, adminLocked: locked },
    { id: 8, label: t('impostazioni'), link: "/app/adminSettings", icon: <SettingsOutlined />, adminLocked: locked },
    { id: 23, label: t('utenti'), link: "/app/users", icon: <PeopleAlt />, adminLocked: locked },
    { id: 10, type: "divider", adminLocked: false },
    { id: 11, type: "title", label: t('fatturazione'), adminLocked: false },
    { id: 12, label: t('corsi'), link: "/billing/corsi", icon: <LibraryBooksOutlined />, adminLocked: false },
    { id: 13, label: t('studenti'), link: "/billing/studenti", icon: <SchoolOutlined />, adminLocked: false },
    { id: 14, label: t('ritirati'), link: "/billing/ritirati", icon: <ExitToAppOutlined /> },
    { id: 15, label: t('da_verificare'), link: "/billing/daVerificare", icon: <PausePresentationOutlined />, adminLocked: false },
    { id: 16, label: t('in_ritardo'), link: "/billing/inRitardo", icon: <AlarmOnOutlined />, adminLocked: false },
    { id: 17, type: "divider", adminLocked: false },
    { id: 18, label: t('insegnanti'), link: "/billing/insegnanti", icon: <AccountBox />, adminLocked: false },
    { id: 19, label: t('fatture_insegnanti'), link: "/billing/fattureInsegnanti", icon: <LocalAtmOutlined />, adminLocked: false },
    { id: 24, type: "divider", adminLocked: false },
    { id: 25, label: t('fatt_elett'), link: "/billing/electronicReceipts", icon: <Memory />, adminLocked: false },
  ];

  let studentStructure = [
    { id: 20, label: "Dashboard", link: "/app/dashboard", icon: <DashboardOutlined /> },
    { id: 21, label: "" },
    { id: 0, type: "title", label: t('gestione'), adminLocked: false },
    { id: 1, label: t('corsi'), link: "/app/corsi", icon: <LibraryBooksOutlined />, adminLocked: false },
    { id: 22, label: t('notifiche'), link: "/app/notifiche", icon: <NotificationsActiveOutlined />, adminLocked: false },
    { id: 8, label: t('impostazioni'), link: "/app/userSettings", icon: <SettingsOutlined />, adminLocked: false },
  ];

  let teacherStructure = [
    { id: 20, label: "Dashboard", link: "/app/dashboard", icon: <DashboardOutlined /> },
    { id: 21, label: "" },
    { id: 0, type: "title", label: t('gestione'), adminLocked: false },
    { id: 1, label: t('corsi'), link: "/app/corsi", icon: <LibraryBooksOutlined />, adminLocked: false },
    { id: 22, label: t('notifiche'), link: "/app/notifiche", icon: <NotificationsActiveOutlined />, adminLocked: false },
    { id: 8, label: t('impostazioni'), link: "/app/userSettings", icon: <SettingsOutlined />, adminLocked: false },
  ];

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    style={{position: 'sticky'}}

    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList} style={{ paddingBottom: 100 }} >

        <img alt="" src={logo ? logo : require('../../images/icon.png') } style={{ position: 'relative', width: '80%', left: '10%', marginTop: '10px', marginBottom: '20px' }} />
        { (userType == 0 || userType == 4) && mainStructure.map(link => (
          <SidebarLink
            key={link.id}
            menuClose={() => {
              if(!isPermanent && isSidebarOpened) {
                  isSidebarOpened = false;
                  toggleSidebar(layoutDispatch);
              }
            }}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
            adminLocked = {link.adminLocked}
          />
        ))}
        { userType == 1 && studentStructure.map(link => (
          <SidebarLink
            key={link.id}
            menuClose={() => {
              if(!isPermanent && isSidebarOpened) {
                  isSidebarOpened = false;
                  toggleSidebar(layoutDispatch);
              }
            }}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
            adminLocked = {link.adminLocked}
          />
        ))}
        { userType == 2 && teacherStructure.map(link => (
          <SidebarLink
            key={link.id}
            menuClose={() => {
              if(!isPermanent && isSidebarOpened) {
                  isSidebarOpened = false;
                  toggleSidebar(layoutDispatch);
              }
            }}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
            adminLocked = {link.adminLocked}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
      toggleSidebar(layoutDispatch);
    }
  }
}

export default withRouter(Sidebar);
